import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout only: /palworld-wiki renders the hub, /palworld-wiki/<slug> an article. */
export const Route = createFileRoute("/palworld-wiki")({
  component: Outlet,
});
